<template>
  <div class="container" style="font-family: SourceHanSansCN-Regular;">
    <!--内容-->
    <div class="video-video-title" v-if="contentTop.cover">
      <!--视频展示区域-->
      <div style="z-index: 999" class="video-video-title-video">
        <video
            style="width: 100%; height: 200px;"
            v-if="fileId"
            id="tcPlayerId"
            class="tc-video-container"
            playsinline
            webkit-playinline
            x5-playinline></video>
        <img
            v-else
            style="width: 100%;height: 200px"
            :src="contentTop.cover[1]" alt="">
      </div>
      <div  class="video-video-title-title">
        <div class="title" style="margin-left: 15px;height: 40px">{{contentTop.title}}</div>
        <div class="lookPer">
          <span>
            <van-icon style="z-index: 1" name="eye-o" />
            </span>{{contentTop.browseCount}}次观看</div>
      </div>
    </div>
    <div class="video-include" >
      <van-tabs
          swipeable
          class="tabs"
          color="#45a5e6"
          v-model="active"
          @click="titleClick"
          title-active-color="#45a5e6">
        <van-tab>
          <span class="font-sty" slot="title">介绍</span>
          <div style="background-color: #FFFFFF;overflow-y: scroll;height: 300px;margin-top: 10px">

            <!--介绍-->
            <div class="include-lecturer" id="includeId" >
              <div class="include-lecturer-content" v-if="contentTop.vodIntro">
                <img
                    style="width: 100%;height: auto"
                    :src="contentTop.vodIntro.cover[0]" alt="">
<!--                <div>{{contentTop.vodIntro.title}}</div>-->
                <div v-html="contentTop.vodIntro.intro"></div>
              </div>
            </div>

          </div>
        </van-tab>
        <van-tab>
          <span class="font-sty" slot="title">目录</span>
          <div :style="{backgroundcolor: '#FFFFFF',overflowY: 'scroll',height:innerHeight-350+'px'}">

            <!--目录-->
            <div class="catalogue" id="catalogueId">
              <div class="catalogue-include"></div>
              <div class="catalogue-content" v-if="vodDirectoriesLenght">
                <div class="catalogue-content-list"
                     @click="switchVideo(list.fileId,list)"
                     v-for="(list,index) in contentTop.vodDirectories" :key="index">
                  <div style="width: 40%;margin-bottom: 10px">
                    <img
                        style="width: 95%;height: 80vm;border-radius: 5px"
                        :src="list.cover[0]" alt="">
                  </div>
                  <div :style="{width: '60%',color: list.fileId === fileId  ?'#45A5E6':''}">
                    <div class="font-eli">{{list.title}}</div>
                    <div class="font-name" :style="{marginTop: '5px',color: list.fileId === fileId ?'#45A5E6':''}">{{list.name}}</div>
                    <div style="display: flex">
                      <div class="font-name" :style="{width: '70%',color: list.fileId === fileId  ?'#45A5E6':''}"><span >{{list.hospital}}</span></div>
<!--                      <div class="icon">-->
<!--                        <span><van-icon name="eye-o" />{{ list.browseCount }}</span></div>-->
                    </div>
                  </div>
                </div>
              </div>
              <div
                  v-if="!vodDirectoriesLenght"
                  style="width: 100%;height: 200px;line-height: 200px;text-align: center;color: #9B9B9B">
                暂无目录...
              </div>
            </div>

          </div>
        </van-tab>
        <van-tab>
          <span class="font-sty" slot="title">评论</span>
          <div style="background-color: #FFFFFF;overflow-y: scroll;height: 300px;width: 100%">

            <!--评论-->
            <div class="include-comment" id="commentId" >
              <div class="comment-content" v-if="commentListLenght" style="margin-bottom: 20px">
                  <div class="comment-content-list" v-for="(commit,index) in commentList" :key="index">
                    <div style="display:flex;margin-top: 15px">
                      <div >
                        <img
                            style="width: 50px;height: 50px;border-radius: 25px"
                            :src="commit.headimg" alt="">
                      </div>
                      <div style="margin-left: 10px;margin-top: 5px">
                        <div>{{commit.name}}</div>
                        <div style="color: #9B9B9B;font-size: 12px;margin-top:5px;display: flex;">
                          <div>{{commit.hospitalName}}</div>
                          <div style="margin-left: 30px">{{commit.createdTime}}</div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-left: 60px;font-size: 14px">
                      {{commit.content}}
                    </div>
                    <!--二级回复-->
                    <div v-if="commit.commentTwos !== undefined && commit.commentTwos !== '' && commit.commentTwos !== null">
                      <div style="margin-left: 10%" v-if="commit.commentTwos">
                        <div v-for="(childComm,index) in commit.commentTwos" :key="index">
                          <div style="display:flex;margin-top: 5px">
                            <div >
                              <img
                                  style="width: 50px;height: 50px;border-radius: 25px"
                                  :src="childComm.headimg" alt="">
                            </div>
                            <div style="margin-left: 10px;margin-top: 5px">
                              <div>{{childComm.name}}</div>
                              <div style="color: #9B9B9B;font-size: 12px;margin-top:5px;display: flex;">
                                <div style="
                  width: 55%;
                  display: -webkit-box;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  word-break: break-all;">{{childComm.hospitalName}}</div>
                                <div style="margin-left: 30px">{{childComm.createdTime}}</div>
                              </div>
                            </div>
                          </div>
                          <div style="margin-left: 60px;font-size: 14px">
                            {{childComm.content}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <div
                  v-if="!commentListLenght"
                  style="width: 100%;height: 200px;line-height: 200px;text-align: center;color: #9B9B9B">
                暂无评论...
              </div>
            </div>
          </div>
        </van-tab >
        <van-tab v-if="isOpen">
          <span class="font-sty" slot="title">动态</span>
          <div style="background-color: #FFFFFF;overflow-y: scroll;height: 300px;width: 100%">

<!--            <div v-if="isOpen" style="border-bottom: 5px solid #EEEFF1;"></div>-->
            <!--动态-->
            <div class="message" id="messageId" v-if="isOpen">
<!--              <div class="message-include">动态</div>-->
              <div class="message-content" v-if="dynamicsList">
                <van-row gutter="20">
                  <van-col
                      span="6"
                      style="margin-bottom: 10px"
                      v-for="(img,index) in dynamicsList" :key="index">
                    <div style="width: 100%;">
                      <img
                          style="width: 50px;
                  height:50px;
                  border-radius:50px;
                  position: absolute;
                  left: 50%;
                  margin-left: -25px"
                          :src="img.headImg" alt="">
                    </div>
                    <div style="width: 100%;text-align: center;font-size: 12px">
                      <span>{{img.name}}</span><span><van-icon style="margin-left: 5px" color="#45A5E6" name="eye" /></span>
                    </div>
                  </van-col>
                </van-row>
                <!--        <div class="moreComm" >-->
                <!--          查看更多动态 ></div>-->
              </div>
              <div style="height: 300px">
              </div>
            </div>

          </div>
        </van-tab>
      </van-tabs>
    </div>
    <openAPP/>
  </div>
</template>

<script>
import {getVideoShareList} from "../../service/subscribeShare_api";
export default {
  components: {
    openAPP:()=>import('../../components/share_foot'),
  },
  data(){
    return{
      innerHeight:null,
      fileId:'',
      tcPlayerId: 'tcPlayer' + Date.now(),
      includeHeight:0,
      catalogueHeight:0,
      commentHeight:0,
      messageHeight:0,

      headImg:require('../../assets/image/img.png'),
      commentImg:require('../../assets/image/zan1.png'),
      commentImg2:require('../../assets/image/zan2.png'),
      message:'',
      active:0,
      contentTop:{},
      listId:'',
      commentList:[],
      dynamicsList:[],
      isOpen:0,
      commentListLenght:0,
      vodDirectoriesLenght:0,
      player:null,


      // 节流
      time: undefined,
      // 当前高亮的 title 标志
      index: 0,
      // 右侧滚动区域 DOM
      rightDiv: undefined,
      // 右侧内容 DOM 数组
      content: undefined
    }
  },
  created() {
    this.innerHeight = window.innerHeight
  },
  async mounted() {
    this.listId = this.$route.query.id
    await this.getList()
    await this.getShareList()
  },
  methods:{
    async getShareList() {
      let data = {
        introduction: 'dynamic',
      }
      const response = await getVideoShareList(this.listId, data)
      if (response.code === 0) {
        this.dynamicsList = response.data.dynamics

      }
    },

    titleClick(){
    },
    //获取页面内容
    async getList() {
      const response = await getVideoShareList(this.listId)
      if(response.code === 0){
        this.contentTop = response.data
        this.commentList = response.data.comments
        if(response.data.comments){
          this.commentListLenght = response.data.comments.length
        }
      //  接口中isOpen
        this.isOpen = response.data.isOpen
        this.vodDirectoriesLenght = response.data.vodDirectories.length
      }
    },
    // onClickLeft(){
    //   history.go(-1)
    // },
    switchVideo(fileId,list){
      if(list.type === 'VIDEO'){ //点播
        this.fileId = fileId
        let self = this
        setTimeout(() => {
          self.$nextTick(() => {
            const player = {
              fileID: fileId,
              appID: '1252497858',
              //自动播放
              autoplay: true,
              plugins: {
                ProgressMarker: true
              }
            }
            if(!self.player) {
              self.player = window.TCPlayer('tcPlayerId', player)
            }
            else {
              //动态播放视频
              this.player.loadVideoByID(player);
            }
          })
        }, 0)
      }else if(list.type === 'ARTICLE'){ //文章
        window.location.href = list.articleUrl
      }
    },
  },
}
</script>

<style lang="scss">
::-webkit-scrollbar {
  width: 0;
}
::-webkit-scrollbar-track {
  background-color: #edeff2;
}
.video{
  align-items: center;
  video{
  }
  ::v-deep .video-js{
    width: auto;
    height: 200px;
  }
}

.video-video-title{
  width: 100%;
  border-bottom: 5px solid #EEEFF1;
  .video-video-title-video{
    position: absolute;
    top: 0;
    width: 100%;
    height: 200px;
    background-color: #f5f5f5;
  }
  .video-video-title-title{
    width: 100%;
    height: 70px;
    position: absolute;
    border-bottom: 1px solid #f5f5f5;
    top: 200px;
    .title{
      margin: 5px;
      display: -webkit-box;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
    }
    .lookPer{
      margin-left: 10px;
      margin-bottom: 10px;
      font-size: 14px;
      color: #9B9B9B;;
    }
  }
}
.video-include{
  position: absolute;
  top: 275px;
  width: 100%;
  .tabs{
    //border-bottom: 1px solid #c27575;
    width: 100%;
    height: 44px;
    margin: auto;
    z-index: 999;
  }
  .font-sty{
    font-size: 16px;
  }
}
.lecturer{
  border-bottom: 5px solid #EEEFF1;
  .lecturer-div{
    height: 75px;
    border-radius: 5px;
    background-color: #EEEFF1;
    margin:17px;
    display: flex;
    .lecturer-div-img{
      padding-top: 12px;
      margin-left: 20px;
      img{
        height: 50px;
        width: 50px;
        border-radius: 50px;;
      }
    }
    .include{
      margin-left: 10px;margin-top: 15px;
      .hos{
        color: #9B9B9B;
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
}
.include-lecturer {
  //border-bottom: 5px solid #EEEFF1;
  min-height: 200px;
  .include-lecturer-include{
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #EEEFF1;
    width: 90%;
    margin: auto;
    margin-bottom: 15px;
  }
  .include-lecturer-content{
    width: 90%;
    margin: auto;
    margin-bottom: 15px;
  }
}
.include-comment{
  width: 90%;
  margin: auto;
  .comment{
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #EEEFF1;
    .comment-content-list{
      min-height: 80px;
      width: 100%;
    }
  }
}
.goods-video {
  height: 100%;
  .video-js {
    width: 100%;
    height: 100%;
  }

  .vjs-control-bar {
    bottom:1px;
  }

  .vjs-big-play-button {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    line-height: normal;

    .vjs-icon-placeholder {
      &:before {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: auto;
        height: auto;
      }
    }
  }

  .vjs-control-bar {

    // opacity: 1 !important;
    .vjs-play-control,
    .vjs-fullscreen-control {
      .vjs-icon-placeholder {
        &:before {
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: auto;
          height: auto;
          font-size: 25px;
        }
      }
    }

    .vjs-volume-panel,
    .vjs-picture-in-picture-control {
      display: none;
    }
  }
}
.catalogue {
  height: auto;
  min-height: 200px;
  .catalogue-include{
    height: 5px;
    //line-height: 40px;
    //border-bottom: 1px solid #EEEFF1;
    width: 90%;
    margin: auto;
    margin-bottom: 15px;
  }
  .catalogue-content{
    width: 90%;
    margin: auto;
    margin-bottom: 15px;
    .catalogue-content-list{
      width: 100%;
      height: 100px;
      margin-bottom: 10px;
      border-bottom: 1px solid #f5f5f5;
      display: flex;
      justify-content: space-around;
      .font-eli{
        width: 100%;
        min-height: 40px;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
      .font-name{
        width: 100%;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        word-break: break-all;
        font-size: 12px;
        color: #9B9B9B;
        margin-top: 2px;
      }
      .icon{
         font-size: 12px;color: #9B9B9B;margin-top: 2px;width: 30%;padding-left: 10px;
      }
    }
  }
}
.moreComm{
  width: 100%;
  text-align: center;
  color: #45A5E6;
  margin-top: 10px;
  margin-bottom: 20px;

}
//.comm-input{
//  display: flex;
//  border-top: 1px solid #eae9e9;
//  height: 55px;
//  line-height: 55px;
//  margin-top: 10px;
//  border-bottom: 5px solid #EEEFF1;
//}
.message {
  margin-bottom: 20px;
  min-height: 200px;
  .message-include{
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #EEEFF1;
    width: 90%;
    margin: auto;
    margin-bottom: 15px;
  }
  .message-content{
    width: 90%;
    margin: auto;
    margin-bottom: 15px;
  }
}
</style>
